
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Navigation from "../../components/layout/Navigation";
import Footer from "../../components/layout/Footer";
import FeaturedArticle from "../../components/Blog/FeaturedArticle";
import ArticleCard from "../../components/Blog/ArticleCard";
import CategoryFilter from "../../components/Blog/CategoryFilter";
import { fetchArticles, fetchCategories } from "../../lib/strapi";
import { useRouter } from "next/router";
import styles from "../../styles/blog/blogPage.module.scss";
export default function Blog({ featuredArticle, articles, categories, pagination, activeCategory }) {
    const router = useRouter();
    const pageSchema = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "HFDX Blog",
        "description": "Latest news, insights, and updates from HFDX about DeFi, crypto trading, and decentralized finance.",
        "url": `${process.env.NEXT_PUBLIC_SITE_URL}/blog`,
        "publisher": {
            "@type": "Organization",
            "name": "HFDX",
            "logo": {
                "@type": "ImageObject",
                "url": `${process.env.NEXT_PUBLIC_SITE_URL}/logo.png`
            }
        }
    };
    const handleLoadMore = () => {
        const nextPage = (pagination?.page || 1) + 1;
        const params = new URLSearchParams();
        if (activeCategory)
            params.set('category', activeCategory);
        params.set('page', String(nextPage));
        router.push(`/blog?${params.toString()}`, undefined, { shallow: false });
    };
    const hasMore = pagination && pagination.page < pagination.pageCount;
    return (<MainLayout title="Blog | HFDX" description="Latest news, insights, and updates from HFDX about DeFi, crypto trading, and decentralized finance." keywords="HFDX Blog, Crypto News, DeFi Insights, Decentralized Trading" page="blog_page" alternate="blog" canonical="/blog" loaded={true} schemaData={pageSchema}>
            <Navigation />
            <div className={styles.blogPage}>
                <div className="container">
                    <div className={styles.header}>
                        <h1 className={styles.pageTitle}>Blog</h1>
                        <p className={styles.pageSubtitle}>
                            Insights, updates, and analysis from the HFDX team
                        </p>
                    </div>

                    <CategoryFilter categories={categories} activeCategory={activeCategory}/>

                    {featuredArticle && !activeCategory && (<section className={styles.featuredSection}>
                            <FeaturedArticle article={featuredArticle}/>
                        </section>)}

                    {articles.length > 0 ? (<>
                            <section className={styles.articlesSection}>
                                <h2 className={styles.sectionTitle}>
                                    {activeCategory ? 'Articles' : 'Latest'}
                                </h2>
                                <div className={styles.articlesGrid}>
                                    {articles.map((article) => (<ArticleCard key={article.id} article={article}/>))}
                                </div>
                            </section>

                            {hasMore && (<div className={styles.loadMore}>
                                    <button className={styles.loadMoreBtn} onClick={handleLoadMore}>
                                        Load More
                                    </button>
                                </div>)}
                        </>) : (<div className={styles.empty}>
                            <h3>No articles found</h3>
                            <p>Check back soon for new content.</p>
                        </div>)}
                </div>
            </div>
            <Footer />
        </MainLayout>);
}
async function getServerSideProps({ query }) {
    try {
        const category = query.category || null;
        const page = query.page ? Number(query.page) : 1;
        const [articleData, categories] = await Promise.all([
            fetchArticles({ category, page, pageSize: 10 }),
            fetchCategories(),
        ]);
        let featuredArticle = null;
        let articles = articleData.articles || [];
        if (articles.length > 0 && page === 1 && !category) {
            featuredArticle = articles[0];
            articles = articles.slice(1);
        }
        return {
            props: {
                featuredArticle,
                articles,
                categories,
                pagination: articleData.pagination,
                activeCategory: category || null
            }
        };
    }
    catch (error) {
        console.error('Blog page error:', error?.message);
        return {
            props: {
                featuredArticle: null,
                articles: [],
                categories: [],
                pagination: null,
                activeCategory: query.category || null
            }
        };
    }
}

    async function __Next_Translate__getServerSideProps__1a17ab3f2db__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a17ab3f2db__ as getServerSideProps }
  